var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._b({attrs:{"outlined":_vm.outlined,"value":_vm.currentValue,"messages":[_vm.error],"error":!!_vm.error},on:{"input":function($event){return _vm.updateFieldValue(_vm.name, $event)}}},'v-textarea',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }